import { createContext, useContext, useState, useEffect } from 'react';
import { translations } from '@/i18n/translations';

const LanguageContext = createContext();

const SUPPORTED_LANGS = ['zh-TW', 'zh-CN', 'en'];

function detectBrowserLang() {
  const n = (navigator.language || '').toLowerCase();
  if (n.startsWith('zh')) {
    if (n.includes('cn') || n.includes('hans') || n.includes('sg')) return 'zh-CN';
    return 'zh-TW';
  }
  return 'en';
}

function getQueryLang() {
  const p = new URLSearchParams(window.location.search).get('lang');
  return SUPPORTED_LANGS.includes(p) ? p : null;
}

export function LanguageProvider({ children }) {
  const [lang, setLang] = useState(() => {
    const fromQuery = getQueryLang();
    if (fromQuery) return fromQuery;
    const saved = localStorage.getItem('dzent-lang');
    if (SUPPORTED_LANGS.includes(saved)) return saved;
    return detectBrowserLang();
  });

  useEffect(() => {
    localStorage.setItem('dzent-lang', lang);
    document.documentElement.lang = lang;
  }, [lang]);

  const t = (key) => {
    const keys = key.split('.');
    let value = translations[lang];
    for (const k of keys) {
      value = value?.[k];
    }
    return value || key;
  };

  return (
    <LanguageContext.Provider value={{ lang, setLang, t, SUPPORTED_LANGS }}>
      {children}
    </LanguageContext.Provider>
  );
}

export const useLanguage = () => useContext(LanguageContext);
